import React, { Component } from 'react';
import classnames from 'classnames';
import moment from 'moment';
import { Dropdown, DropdownMenu, DropdownItem } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import {connect} from "react-redux";
import { toast } from 'react-toastify';
import Request from "config/Request.js"
import {UpdateAllTenantSession} from "store/tenant/action.js"
//Auth Presenter
import AuthPresenter from '../../../user/presenter.js'
//Booking Presenter
import PresenterBooking from '../../../asset/simple_asset/presenter.js';
import RequestPropertiesBooking from '../../../asset/simple_asset/helper/request.props.js';
//Reassign Presenter
import {
  PresenterReadAsMaster,
  PresenterReadBookedAsset,
  PresenterCancelReasign,
  PresenterRegisterQRReasign,
  PresenterReadIncomingMessage,
  PresenterConfirmationAnswer
} from '../../../home/presenter.js';

import {
  ReadAsMaster,
  // ReadPropsMyAsset,
  ReadPropsBookedAsset,
  // ReadPropsAllAsset,
  UpdatePropsCancelReasign,
  // ReadPropsQRReassign,
  RegisterPropsQRReassign,
  ReadPropsIncomingMessage,
  RegisterConfirmationAnswer
} from '../../../home/helper/request.props.js';

import FormHelper from '../../../home/helper/form.js';

/* === MODALS === */
import ModalQRScanner from '../../../qrreader/helper/component/Modal/ModalQRScanner.js';
import ModalQRGenerator from '../../../qrreader/helper/component/Modal/ModalQRGenerator.js';
import ModalAcceptQRReassign from '../../../qrreader/helper/component/Modal/ModalAcceptQRReassign.js';
import ModalDialogueQR from '../../../qrreader/helper/component/Modal/ModalDialogueQR.js';
import ModalInsertTag from '../../../qrreader/helper/component/Modal/ModalInsertTag.jsx';
import ModalBooking from '../../../asset/simple_asset/helper/component/Modal/ModalBooking.js';
import ModalDetailAsset from '../../../asset/simple_asset/helper/component/Modal/ModalDetailAsset.js';
import ModalReasign from '../../../home/helper/component/Modal/ModalReasign.js';
import ModalMoveAsset from '../../../home/helper/component/Modal/ModalMoveAsset.js';
import ModalExtend from '../../../home/helper/component/Modal/ModalExtend.js';
import ModalMaintenanceRequest from '../../../maintenance/helper/component/Modal/ModalMaintenanceRequest.js';
import ModalReportproblem from '../../../maintenance/helper/component/Modal/ModalReportproblem.js';
import ModalDueDate from "../../../home/helper/component/Modal/ModalDueDate.js";
import ModalReject from '../../../home/helper/component/Modal/ModalReject.js';
import ModalDialogue from '../../../home/helper/component/Modal/ModalDialogue.js';

import toUTCtime from '../../../helper/UTCtime';
import getLogoBranding from "utils/getLogoBranding.js"
import windowStop from '../../../utils/windowStop.js';

class Header extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      modalQRScanner  : false,
      modalQRGenerator: false,
      modalDetail     : false,
      modalBooking    : false,
      modalReassign   : false,
      modalMoveAsset  : false,
      modalExtend     : false,
      modalInsertTag  : false,
      modalAcceptQRReassign    : false,
      modalMaintenanceRequest  : false,
      modalReportProblem       : false,
      modalDialogue 					 : false,
      modalDialogueQR 				 : false,
      dropdownOpen             : false,
      ActiveTabNotes           : false,
      isUpdateReservation      : false,
      nextRsv 								 : false,
      SelectedItem          : null,
      ConfirmationData 			: null,
      DateBookingStart_UTC  : null,
      DateBookingStart      : null,
      DateBookingEnd_UTC    : null,
      DateBookingEnd        : null,
      qrReassignValue       : null,
      qrReassignData 				: null,
      SITE                  : null,
      LOCATION              : null,
      USER                  : null,
      newTag 								: null
    };

    //Bind Event
    this.__Logout__           = this.__Logout__.bind(this);

    this._mounted = false
    this._hasMount = this._hasMount.bind(this)

    this.closeModalQRScanner  = this.closeModalQRScanner.bind(this);
    this.openModalQRScanner   = this.openModalQRScanner.bind(this);

    this.closeModalQRGenerator  = this.closeModalQRGenerator.bind(this);
    this.openModalQRGenerator   = this.openModalQRGenerator.bind(this);

    this.openModalDetail      = this.openModalDetail.bind(this);
    this.closeModalDetail     = this.closeModalDetail.bind(this);

    this.openModalBooking     = this.openModalBooking.bind(this);
    this.closeModalBooking    = this.closeModalBooking.bind(this);

    this.openModalReassign    = this.openModalReassign.bind(this);
    this.closeModalReassign   = this.closeModalReassign.bind(this);

    this.openModalMoveAsset   = this.openModalMoveAsset.bind(this);
    this.closeModalMoveAsset  = this.closeModalMoveAsset.bind(this);

    this.openModalExtend      = this.openModalExtend.bind(this);
    this.closeModalExtend     = this.closeModalExtend.bind(this);

    this.openModalInsertTag 	= this.openModalInsertTag.bind(this);
    this.closeModalInsertTag 	= this.closeModalInsertTag.bind(this);

    this.readAssetData        = this.readAssetData.bind(this);
    this.cancelReassign       = this.cancelReassign.bind(this);

    this.onReadAssetDetailSuccess   = this.onReadAssetDetailSuccess.bind(this);
    this.onReadFailed               = this.onReadFailed.bind(this);

    this.openModalReqMaintenance		= this.openModalReqMaintenance.bind(this);
    this.closeModalReqMaintenance		= this.closeModalReqMaintenance.bind(this);

    this.openModalAcceptQRReassign 	= this.openModalAcceptQRReassign.bind(this);
    this.closeModalAcceptQRReassign = this.closeModalAcceptQRReassign.bind(this);

    this.openModalDialogueQR = this.openModalDialogueQR.bind(this);
    this.closeModalDialogueQR = this.closeModalDialogueQR.bind(this);

    this.toggleModalProblem  = this.toggleModalProblem.bind(this);
    this.toggleModalDueDate  = this.toggleModalDueDate.bind(this);
    this.toggleModalReject 	 = this.toggleModalReject.bind(this);
    this.toggleModalDialogue = this.toggleModalDialogue.bind(this);

    this.onScanQRSuccess 		= this.onScanQRSuccess.bind(this);
    this.confirm 				 		= this.confirm.bind(this);
    this.confirmAction 	 		= this.confirmAction.bind(this);
    this.confirmationAnswer = this.confirmationAnswer.bind(this);

    this.requestLogoSummary = this.requestLogoSummary.bind(this)
    this.requestLogoSummarySuccess = this.requestLogoSummarySuccess.bind(this)
    this.requestLogoSummaryFailed = this.requestLogoSummaryFailed.bind(this)

    this.gotoHome = this.gotoHome.bind(this)
    this.gotoHelp = this.gotoHelp.bind(this)
  }

  gotoHome() {
    const {pathname} = this.props.ParentProps.location

    if(pathname.startsWith("/su")) {
      this.props.ParentProps.history.push('/su');
    } else {
      this.props.ParentProps.history.push('/home');
    }
  }

  gotoHelp() {
    window.open("http://apphelp.assetvault.co.nz/", "_blank")
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-hidden');
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-mobile-show');
  }

  asideToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('aside-menu-hidden');
  }

/*  =============================== QR Component =========================== */
  openModalQRScanner(){
    this.setState({
      modalQRScanner : true
    })
  }

  closeModalQRScanner(){
    this.setState({
      modalQRScanner : false
    })
  }

  onScanQRSuccess(type, resultData){
    if (['asset', 'tag'].includes(type)){
      this.openModalDetail(resultData);
      if(resultData.Owner.Username !== this.props.UserReducer.username){
        this.readConfirmationMessage(resultData.Alias)
      }
    }else if(type === 'confirmation'){
      resultData.Asset.ToReservation = null
      if(resultData.Asset.Owner.Username === this.props.UserReducer.username){
        toast.warning('This asset already assigned to You!');
        return
      }else if(resultData.Asset.NextReservation !== null){
        if (this.props.UserReducer.username === resultData.Asset.NextReservation.User.Username){
          if (moment(resultData.Asset.NextReservation.StartDate) < moment()) {
            resultData.Asset.ToReservation = resultData.Asset.NextReservation
            this.openModalAcceptQRReassign(resultData)
          }else{
            this.openModalDialogueQR(resultData)
          }
        }else{
          if (moment(resultData.Asset.NextReservation.StartDate) < moment()) {
            toast.error('Can\'t accept this asset because already booked by ' + resultData.Asset.NextReservation.User.Username)
          } else {
            this.openModalAcceptQRReassign(resultData)
          }
        }
      }else{
        this.openModalAcceptQRReassign(resultData)
      }
    }else{
      toast.error('Undefined QR Result Type')
      return
    }
  }

  closeModalDetail(){
    this.setState({
      modalDetail: false,
      ActiveTabNotes: false
    })
  }

  openModalDetail(assetData){
    this.setState({
      SelectedItem   : assetData,
      modalDetail    : true
    })
  }

  updateData(data, type){
    if(this.state.SelectedItem !== null){
      if(['asset','qr-accept'].includes(type)){
      	if(data.Alias === this.state.SelectedItem.Alias){
      	  this.setState({
    	      SelectedItem : Object.assign(this.state.SelectedItem, data)
    	    })
      	}
      }else if(['accept', 'register'].includes(type)){
      	if(data.Asset.Alias === this.state.SelectedItem.Alias){
          this.setState({
            SelectedItem : {
              ...this.state.SelectedItem,
              Confirmation : data
            }
          })
          this.readAssetData();
      	}
      }
    }else{
      return
    }
  }

  // ---------------------------- Insert Asset Tag --------------------
  openModalInsertTag(tag){
  	this.setState({
  		modalInsertTag : true,
  		newTag : tag
  	})
  }

  closeModalInsertTag(){
  	this.setState({ modalInsertTag : false})
  }
  // ---------------------------- End Insert Asset Tag ----------------
  // --------------------------- Booking -------------------------
  openModalBooking(date) {
    if(date !== null) {
        date.start._d.setHours(9);
        date.start._d.setMinutes(0);
        date.start._d.setSeconds(0);

        date.end._d.setHours(8);
        date.end._d.setMinutes(59);
        date.end._d.setSeconds(59);

        this.setState({
            modalBooking         : true,
            DateBookingStart     : date.start._d,
            DateBookingStart_UTC : toUTCtime(date.start._d),
            DateBookingEnd       : date.end._d,
            DateBookingEnd_UTC   : toUTCtime(date.end._d),
        })
    } else {
        toast.warning("select the date of booking")
    }
  }

  closeModalBooking(){
      this.setState({
          modalBooking : false,
      })
  }

  loadMaster() {
      PresenterBooking.ReadAsMaster(
        RequestPropertiesBooking.ReadAsMaster("SITE", this, this.ReadMasterSuccess, this.onReadFailed)
      )
      PresenterBooking.ReadAsMaster(
        RequestPropertiesBooking.ReadAsMaster("LOCATION", this, this.ReadMasterSuccess, this.onReadFailed)
      )
      PresenterReadAsMaster(
        ReadAsMaster("USER", this, this.ReadMasterSuccess, this.onReadFailed)
      )
  }

  ReadMasterSuccess(params, response) {
    switch(params.action) {
      case "USER":
          params.self.setState({ USER: response.data })
          break;
      case "SITE":
          params.self.setState({ SITE: response.data })
          break;
      case "LOCATION":
          params.self.setState({ LOCATION: response.data })
          break;
      default:
          break;
    }
  }

  // ------------------------- End Booking --------------------
  // ------------------------------ Reassign ------------------------------

  openModalReassign(data, change = false){
    this.setState({
      SelectedItem   : data,
      modalReassign  : true
    });
  }

  closeModalReassign() {
    this.setState({
      // SelectedItem  : null,
      modalReassign : false
    });
  }

  // ------------------------------ End Reassign ------------------------------
  // ------------------------------ Reassign By QR ------------------------------
  openModalQRGenerator(assetAlias){
    this.setState({
      modalQRGenerator : true
    })

    PresenterRegisterQRReasign(
      RegisterPropsQRReassign(
        'generate', this,
        this.onRegisterQRReassignSuccess.bind(this),
        this.onRegisterQRReassignFailed.bind(this),
        assetAlias
      )
    )
  }

  closeModalQRGenerator(){
    this.setState({
      modalQRGenerator : false
    })
  }

  openModalAcceptQRReassign(data){
  	this.setState({
  		qrReassignData : data,
  		modalAcceptQRReassign : true
  	})
  }

  openModalDialogueQR(data){
  	this.setState({
  		qrReassignData : data,
  		modalDialogueQR : true
  	})
  }

  closeModalDialogueQR(action = false){
  	this.setState({
  		nextRsv : action,
  		modalDialogueQR : false
  	})
  }

  closeModalAcceptQRReassign(){
  	this.setState({
  		modalAcceptQRReassign : false
  	})
  }

  onRegisterQRReassignSuccess(params, response){
    this.setState({
      qrReassignValue : response.data.Alias
    })
  }

  onRegisterQRReassignFailed(params, response){
  }
  // ------------------------------ Cancel Reassign ------------------------------
  cancelReassign(data) {
    this.requestParams = {
      Alias : data.Confirmation.Alias
    }
    PresenterCancelReasign(
      UpdatePropsCancelReasign(this, this.OnCancelSuccsess.bind(this), this.OnCancelFailed.bind(this))
    )
  }

  OnCancelSuccsess(params, response) {
    toast.success("Success cancel reasign");
    this.readAssetData();
    // params.self.props.self.updateRow(response.data, true);
  }

  OnCancelFailed(params, response) {
    toast.error(response.data.detail)
  }
  // ------------------------------ End Cancel Reassign ------------------------------
  // ------------------------------ Reassign Confirmation ----------------------------
  readConfirmationMessage(assetAlias){
    this.nextParams = {
      type  : 'in',
      status: 'unconfirmed',
      search: assetAlias,
    };

    PresenterReadIncomingMessage(
      ReadPropsIncomingMessage(
        'Read', this,
        this.onReadConfirmationSuccess.bind(this),
        this.onReadFailed
      )
    )
  }

  onReadConfirmationSuccess(params, response){
  	if(response.data.results[0]){
  		this.setState({
  			SelectedItem : {
  				...this.state.SelectedItem,
  				Confirmation : response.data.results[0]
  			}
  		})
  	}
  }

  confirmAction(action, data = null) {
		if(action) {
			this.toggleModalDueDate(data);
		} else {
			this.toggleModalReject(data);
		}
	}

	confirm(action, data = null){
		if(data.NextReservation !== null){
			if (this.props.UserReducer.username === data.NextReservation.User.Username){
				this.toggleModalDialogue(data, false)
			}else{
				this.confirmAction(action, data)
			}
		}else{
			this.confirmAction(action, data)
		}
	}

	confirmationAnswer(action, data) {
	  if(action === 'accept') {
	      // Set time to 2 (utc +0)
	      data.startDate._d.setHours(8);
	      data.startDate._d.setMinutes(59);
	      data.startDate._d.setSeconds(59);

	      this.RequestParams = {
	          ActiveDataModal     : data.ActiveDataModal,
	          DueDateToUTCtime    : toUTCtime(data.startDate._d),
	          Answer              : 'yes',
	          MyReservation       : null,
	          StartDate           : null,
	          Site                : data.Site.value,
	          Location            : data.Location.value,
	      }

	      if(this.state.nextRsv){
	          data.chStartDate._d.setHours(9);
	          data.chStartDate._d.setMinutes(0);
	          data.chStartDate._d.setSeconds(0);

	          this.RequestParams.StartDate = toUTCtime(data.chStartDate._d)
	          this.RequestParams.MyReservation = data.nextReservation
	      }

	      if(!FormHelper.ValidateFormAcceptReassign(this.RequestParams)) {
	          return
	      }

	      PresenterConfirmationAnswer(
	          RegisterConfirmationAnswer(
	          	"accept", this,
	          	this.OnRegisterConfirmationAnswerSuccsess.bind(this),
	          	this.OnRegisterConfirmationAnswerFailed.bind(this)
	          )
	      )

	  } else {
	      this.RequestParams = {
	          ActiveDataModal: data.ActiveDataModal,
	          DueDateToUTCtime: null,
	          Answer: 'no',
	      }
	      PresenterConfirmationAnswer(
	          RegisterConfirmationAnswer(
	          	"reject", this,
	          	this.OnRegisterConfirmationAnswerSuccsess.bind(this),
	          	this.OnRegisterConfirmationAnswerFailed.bind(this)
	          )
	      )
	  }
	}

	OnRegisterConfirmationAnswerSuccsess(params, response) {
	    if( params.action === 'accept' ) {
        toast.success("Accept reasign success");
	      this.setState({
	          modalDueDate  : false,
	      })
	    } else {
        toast.success("Reject reasign success");
		    this.setState({
		        modalReject  : false,
		    })
	    }
	    // this.readAssetData();
	}

	OnRegisterConfirmationAnswerFailed(params, response) {
	    try {
	      if(response.hasOwnProperty('data')) {
	        if(response.data.hasOwnProperty('detail')) {
	          toast.error(response.data.detail)
	        }
	      }
	    }catch(error) {

	    }
	}


  toggleModalDialogue(data, action=false){
      this.setState({
          nextRsv : action,
          ConfirmationData: data,
          modalDialogue:!this.state.modalDialogue
      })
  }

  toggleModalDueDate(data,myBooking=false) {
      this.setState({
          ConfirmationData: data,
          modalDueDate   : !this.state.modalDueDate,
      })
  }

  toggleModalReject(data){
      this.setState({
          ConfirmationData: data,
          modalReject : !this.state.modalReject
      })
  }
  // ------------------------------ End Reassign Confirmation ------------------------
  // ------------------------------ Move Asset ------------------------------

  openModalMoveAsset(data) {
    this.setState({
      SelectedItem  : data,
      modalMoveAsset : true
    });
  }

  closeModalMoveAsset(){
    this.setState({
      modalMoveAsset : false
    });
  }
  // ------------------------------ End Move Assset ------------------------------
  // ------------------------------ Extend Asset ------------------------------

  openModalExtend(data) {
    this.setState({
      modalExtend: true,
      SelectedItem: data
    })
  }

  closeModalExtend() {
   this.setState({
     modalExtend: false,
   })
  }

  // ------------------------------ End Extend Asset ------------------------------
  // ----------------------------- Maintenance -------------------------------------
  openModalReqMaintenance(){
    this.setState({
      modalMaintenanceRequest : true,
    })
  }

  closeModalReqMaintenance(){
    this.setState({
      modalMaintenanceRequest : false,
    })
  }
  // ----------------------------- End Maintenance -----------------------------------
  // ----------------------------- Report Problem -------------------------------
  toggleModalProblem(){
    this.setState({modalReportProblem: !this.state.modalReportProblem})
  }
  // ----------------------------- End Report Problem ------------------------------
  // ------------------------------ On Success Action ------------------------------
  readAssetData(data){
    PresenterReadBookedAsset(
      ReadPropsBookedAsset(
        'getDetails', this,
        this.onReadAssetDetailSuccess,
        this.onReadFailed,
        'field=&search=',
        'ordering=-SortDate,-CreatedTime',
        1,
        this.state.SelectedItem.Alias
      )
    )
  }

  onReadAssetDetailSuccess(params, response){
    if(response.data.results[0]){
      this.setState({
        SelectedItem : {
          ...response.data.results[0],
          Confirmation : this.state.SelectedItem.Confirmation
        }
      })
    }
  }

  onReadFailed(params, response){
  }
  // ------------------------------ End On Success Action ------------------------------
  // =============================== END QR Component =========================== //

  __GenerateRequestParameter__(){
    return {
        UserReducer: this.props.UserReducer,
        RunRedux : this.props.RunRedux,
        onloggedout : this.__OnLoggedOut__,
        history: this.props.ParentProps.history,

    }
  }
  __Logout__(){
    AuthPresenter.Logout(this.__GenerateRequestParameter__())
  }
  __OnLoggedOut__(history){
    history.push('/login/');
  }

  onClickProfil() {
    const {pathname} = this.props.ParentProps.location

    if(pathname.startsWith("/su")) {
      this.props.ParentProps.history.push('/su/user/settings');
    } else {
      this.props.ParentProps.history.push('/user/settings');
    }

  }

  renderNotificationCounter(){
    if(this.props.notificationCount > 0){
      let num = this.props.notificationCount
      if(this.props.notificationCount > 99){
        num = '99+'
      }
      return([
        <span className="badge badge-pill badge-danger">{num}</span>,
        <span className="badge badge-pill badge-danger notification-counter">{num}</span>
      ])
    }else{
      return([null,null])
    }
  }

  requestLogoSummary() {
    Request(
      "get",
      "get-summary-logo",
      {"Authorization" : "Bearer " + this.props.UserReducer.token},
      {},
      [],
      this.requestLogoSummarySuccess,
      this.requestLogoSummaryFailed
    )
  }

  requestLogoSummarySuccess(response) {
    this.props.RunRedux(UpdateAllTenantSession(response.data))
  }

  requestLogoSummaryFailed(error) {

  }

  _hasMount() {
    if(this._mounted) {
      this.requestLogoSummary()
      this.props.onRef(this);
    }
  }

  componentDidMount(){
    this._mounted = true
    this._hasMount()
  }

  componentWillUnmount() {
    this._mounted = false
    this.props.onRef(undefined)
    windowStop()
  }

  renderMenuRestriction() {
    const {pathname} = this.props.ParentProps.location
    const {UserReducer} = this.props

    // render menu admin
    if(UserReducer.props.isAdmin) {
      // Menu admin
      if(pathname.startsWith("/su")) {
        this.props.ParentProps.history.push('/page/restriction/')
      }

      let menu_admin = [
        <li key={"ma1"} className="nav-item px-1">
          <NavLink className="nav-link link-passive" id="pull-padding-tb" activeClassName={ 'active-menutop' } to="/home">Dashboard {/*<span className="badge badge-for-top-menu badge-pill badge-danger">2</span>*/}</NavLink>
        </li>,
        <li key={"ma2"} className="nav-item px-1">
          <NavLink className="nav-link link-passive" id="pull-padding-tb" activeClassName={ 'active-menutop' }  to="/assets">Assets /Tools</NavLink>
        </li>,
        <li key={"ma3"} className="nav-item px-1">
          <NavLink className="nav-link link-passive" id="pull-padding-tb" activeClassName={ 'active-menutop' }  to="/job">Jobs</NavLink>
        </li>,
        <li key={"ma4"} className="nav-item px-1">
          <NavLink className="nav-link link-passive" id="pull-padding-tb" activeClassName={ 'active-menutop' }  to="/user">Users</NavLink>
        </li>,
        <li key={"ma5"} className="nav-item px-1">
          <NavLink className="nav-link link-passive" id="pull-padding-tb" activeClassName={ 'active-menutop' }  to="/report">Reports</NavLink>
        </li>,
        <li key={"ma6"} className="nav-item px-1" > {/*key="admin"*/}
          <NavLink className="nav-link link-passive" id="pull-padding-tb" activeClassName={ 'active-menutop' } to="/admin/all-activities">Admin</NavLink>
        </li>,
        <li key={"ma7"} className="nav-item px-1" > {/*key="setting"*/}
          <NavLink className="nav-link link-passive" id="pull-padding-tb" activeClassName={ 'active-menutop' } to="/data-master/tenant-setting">Setting</NavLink>
        </li>,
        <li key={"ma8"} className="nav-item px-1" > {/*key="maintenance"*/}
          <NavLink className="nav-link link-passive" id="pull-padding-tb" activeClassName={ 'active-menutop' } to="/admin/maintenance">Maintenance</NavLink>
        </li>
      ]
      return (menu_admin)

    } else if(UserReducer.props.is_superuser) {
      // Menu superuser
      if(pathname.startsWith("/data-master") ||
         pathname.startsWith("/home") ||
         pathname.startsWith("/assets") ||
         pathname.startsWith("/job") ||
         pathname.startsWith("/user") ||
         pathname.startsWith("/admin") ||
         pathname.startsWith("/report")) {
        this.props.ParentProps.history.push('/page/restriction/');
      }
      return null

    } else if(!UserReducer.props.isAdmin && !UserReducer.props.is_superuser) {
      // Menu common user
      if(pathname.startsWith("/data-master") ||
         pathname.startsWith("/admin") ||
         pathname.startsWith("/su") ||
         pathname.startsWith("/report")) {
        this.props.ParentProps.history.push('/page/restriction/');
      }

      let menu_user = [
        <li key={"um1"} className="nav-item px-1">
          <NavLink className="nav-link link-passive" id="pull-padding-tb" activeClassName={ 'active-menutop' } to="/home">Dashboard {/*<span className="badge badge-for-top-menu badge-pill badge-danger">2</span>*/}</NavLink>
        </li>,
        <li key={"um2"} className="nav-item px-1">
          <NavLink className="nav-link link-passive" id="pull-padding-tb" activeClassName={ 'active-menutop' }  to="/assets">Assets /Tools</NavLink>
        </li>,
        <li key={"um3"} className="nav-item px-1">
          <NavLink className="nav-link link-passive" id="pull-padding-tb" activeClassName={ 'active-menutop' }  to="/job">Jobs</NavLink>
        </li>,
        <li key={"um4"} className="nav-item px-1">
          <NavLink className="nav-link link-passive" id="pull-padding-tb" activeClassName={ 'active-menutop' }  to="/user">Users</NavLink>
        </li>,
      ]
      return (menu_user)
    }
  }

  getLogo() {
    if(this.props.UserReducer.props.is_superuser) {
      return null
    }else {
      return this.props.TenantReducer.dashboard
    }
  }

  render() {
    const {UserReducer} = this.props
    const {pathname} = this.props.ParentProps.location

    if(!UserReducer.is_auth){
      this.props.ParentProps.history.push('/login/'); //redirect to home page
      return null
    } else {
      return (
        <header className="app-header navbar">
          <button className="navbar-toggler mobile-sidebar-toggler d-lg-none" onClick={this.mobileSidebarToggle} type="button">&#9776;</button>
          <a
            tabIndex="0"
            role="button"
            className="navbar-brand"
            style={{
              "backgroundImage" : "url(" + getLogoBranding('dashboard', this.getLogo()) + ")",
            }}
            onClick={this.gotoHome}
          >&nbsp;</a>
          <button className="navbar-toggler sidebar-toggler d-md-down-none" onClick={this.sidebarToggle} >☰</button>
          <ul className="nav navbar-nav d-md-down-none">
            {this.renderMenuRestriction()}
          </ul>
          <ul className={classnames("nav navbar-nav ml-auto", {"spaceRRR" : pathname.startsWith("/su")})}>
      			<li className="nav-item dropdown">
      				<Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
      				  <button onClick={this.toggle} className="nav-link dropdown-toggle nav-link" data-toggle="dropdown" aria-haspopup="true" aria-expanded={this.state.dropdownOpen}>
      				    <span className="d-md-down-none">{UserReducer.username}</span>
                  <span className="icon-options-vertical i-o-m"></span>
      				  </button>
      				  <DropdownMenu className="dropdown-menu-right">
      				    <DropdownItem header className="text-center"><strong>Account</strong></DropdownItem>
                  <DropdownItem
                    onClick={()=>this.onClickProfil()} className="text-center">
                    <div>{UserReducer.props.first_name +" "+ UserReducer.props.last_name}</div>
                    {pathname.startsWith("/su") || pathname.startsWith("/page/restriction/") ? null :
                      <span className="small">Tenant: {UserReducer.props.tenant}</span>
                    }
                  </DropdownItem>

                  <DropdownItem onClick={()=>this.onClickProfil()}><i className="fa fa-user"></i> Profile</DropdownItem>
                  {pathname.startsWith("/su") || pathname.startsWith("/page/restriction/") ? null :
                    <DropdownItem onClick={this.asideToggle}>
                      <i className="icon-speech"></i> Chat {this.renderNotificationCounter()[0]}
                    </DropdownItem>
                  }

                  {pathname.startsWith("/su") || pathname.startsWith("/page/restriction/") ? null :
                    <DropdownItem onClick={()=> this.openModalQRScanner()}><i className="fa fa-qrcode"></i> QR Scan</DropdownItem>
                  }

                  {pathname.startsWith("/su") || pathname.startsWith("/page/restriction/") ? null :
                    <DropdownItem onClick={()=> this.gotoHelp()}><i className="fa fa-question"></i> Help </DropdownItem>
                  }

      				    <DropdownItem onClick={()=> this.__Logout__()}><i className="fa fa-lock"></i> Logout</DropdownItem>
      				  </DropdownMenu>
      				</Dropdown>
      			</li>

            {pathname.startsWith("/su") || pathname.startsWith("/page/restriction/") ? null :
              <li className="nav-item d-md-down-none">
                <button className="navbar-toggler aside-menu-toggler d-md-down-none" onClick={this.asideToggle} >
                  <i className="icon-speech"></i>
                  {this.renderNotificationCounter()[1]}
                 {/* <span className="badge badge-pill badge-danger notification-counter">{this.props.notificationCount}</span>*/}
                </button>
              </li>
            }

          </ul>

          <ModalQRScanner
            onSuccess       = {this.onScanQRSuccess}
            isOpen          = {this.state.modalQRScanner}
            closeModal      = {this.closeModalQRScanner}
            openModalInsertTag = {this.openModalInsertTag}
            scanType        = "asset"
            data            = {null}
            RunRedux        = {this.props.RunRedux}
            UserReducer     = {this.props.UserReducer}
          />

          <ModalQRGenerator
            onSuccess       = {() => null}
            closeModal      = {this.closeModalQRGenerator}
            isOpen          = {this.state.modalQRGenerator}
            QRvalue         = {this.state.qrReassignValue}
            QRtype          = 'confirmation'
            modalTitle      = 'QR Confirmation'
            message         = 'Scan This QR Code to Confirm'
            UserReducer     = {this.props.UserReducer}
          />

          <ModalInsertTag
          	isOpen = {this.state.modalInsertTag}
          	closeModal = {this.closeModalInsertTag}
          	newTag = {this.state.newTag}
          	openModalQRScanner = {this.openModalQRScanner}
            history = {this.props.ParentProps.history}

            RunRedux = {this.props.RunRedux}
            UserReducer = {this.props.UserReducer}
          />

          <ModalBooking
            siteMaster            = {this.state.SITE}
            locationMaster        = {this.state.LOCATION}
            selectedItem          = {this.state.SelectedItem}
            dateBookingStart_UTC  = {this.state.DateBookingStart_UTC}
            dateBookingEnd_UTC    = {this.state.DateBookingEnd_UTC}
            dateBookingStart      = {this.state.DateBookingStart}
            dateBookingEnd        = {this.state.DateBookingEnd}
            onRegisterSuccess     = {() => this.setState({
              isUpdateReservation  : true,
              disabledBook         : true
            })}

            closeModal            = {this.closeModalBooking}
            isOpen                = {this.state.modalBooking}

            UserReducer           = {this.props.UserReducer}
          />

          <ModalReasign
            selectedItem        = {this.state.SelectedItem}
            modalState          = {this.state.modalReassign}
            closeModal          = {this.closeModalReassign}
            userData            = {this.state.USER}
            onReassignSuccess   = {this.readAssetData}
            isPerUser           = {false}
            bulkMode            = {false}

            UserReducer         = {this.props.UserReducer}
          />

          <ModalAcceptQRReassign
            modalData = {this.state.qrReassignData}
            masterSite = {this.state.SITE}
            masterLocation = {this.state.LOCATION}
            nextReservation = {this.state.nextRsv}
            onSuccess = {() => null}
            onClose = {() => this.setState({ nextRsv : false })}
            isOpen = {this.state.modalAcceptQRReassign}
            closeModal = {this.closeModalAcceptQRReassign}
            UserReducer = {this.props.UserReducer}
          />

          <ModalDueDate
              activeDataModal = {this.state.ConfirmationData}
              masterSite = {this.state.SITE}
              masterLocation = {this.state.LOCATION}
              nextReservation = {this.state.nextRsv}
              onClose = {() => this.setState({ nextRsv : false })}
              isOpen = {this.state.modalDueDate}
              toogleModalDueDate = {this.toggleModalDueDate}
              confirmationAnswer = {this.confirmationAnswer}
              UserReducer = {this.props.UserReducer}
          />

          <ModalReject
              activeDataModal = {this.state.ConfirmationData}
              toogleModalReject = {this.toggleModalReject}
              isOpen = {this.state.modalReject}
              confirmationAnswer = {this.confirmationAnswer}
          />

          <ModalDialogue
              activeDataModal = {this.state.ConfirmationData}
              isOpen = {this.state.modalDialogue}
              toggleModalDialogue = {this.toggleModalDialogue}
              toogleModalDueDate = {this.toggleModalDueDate}
          />

          <ModalDialogueQR
              modalData = {this.state.qrReassignData}
              isOpen = {this.state.modalDialogueQR}
              closeModal = {this.closeModalDialogueQR}
              openModalAcceptQRReassign = {this.openModalAcceptQRReassign}
          />

          <ModalMoveAsset
            siteMaster       = {this.state.SITE}
            locationMaster   = {this.state.LOCATION}
            isOpen           = {this.state.modalMoveAsset}
            closeModal       = {this.closeModalMoveAsset}
            onMoveSuccess    = {() => null}
            SelectedItem     = {this.state.SelectedItem}

            UserReducer      = {this.props.UserReducer}
          />

          <ModalExtend
            UserReducer = {this.props.UserReducer}
            isToggle    = {this.state.modalExtend}
            open        = {this.openModalExtend}
            close       = {this.closeModalExtend}
            data        = {this.state.SelectedItem}
            onSuccess   = {() => null}
          />

          <ModalMaintenanceRequest
            modalMaintenanceRequest={this.state.modalMaintenanceRequest}
            openModal={this.openModalReqMaintenance}
            closeModal={this.closeModalReqMaintenance}
            asset={{
              assetName : (this.state.SelectedItem ? this.state.SelectedItem.Name : null),
              assetAlias : (this.state.SelectedItem ? this.state.SelectedItem.Alias : null)
            }}
            newRow={() => null}
            UserReducer={this.props.UserReducer}
          />

          <ModalReportproblem
            modalReportProblem={this.state.modalReportProblem}
            toggleModal={this.toggleModalProblem}
            asset={{
              assetName : (this.state.SelectedItem ? this.state.SelectedItem.Name : null),
              assetAlias : (this.state.SelectedItem ? this.state.SelectedItem.Alias : null)
            }}
            UserReducer={this.props.UserReducer}
          />

          <ModalDetailAsset
            activeTabNotes         = {this.state.ActiveTabNotes}
            isUpdateReservation    = {this.state.isUpdateReservation}
            dateBookingStart_UTC   = {this.state.DateBookingStart_UTC}
            dateBookingEnd_UTC     = {this.state.DateBookingEnd_UTC}
            selectedItem           = {this.state.SelectedItem}
            isOpen                 = {this.state.modalDetail}
            closeModal             = {this.closeModalDetail}
            isFromQR               = {true}
            setIsUpdateReservation = {(state) => this.setState({
              isUpdateReservation : state
            })}

            //==================== isFromQR : true ======================//
            toggleModalBooking      = {this.openModalBooking}
            toggleModalProblem      = {this.toggleModalProblem}
            openModalReassign       = {this.openModalReassign}
            openModalMoveAsset      = {this.openModalMoveAsset}
            openModalExtend         = {this.openModalExtend}
            openModalReqMaintenance = {this.openModalReqMaintenance}
            openModalQRReassign     = {this.openModalQRGenerator}
            cancelReassign          = {this.cancelReassign}
            confirm 								= {this.confirm}
            confirmAction 					= {this.confirmAction}
            //===========================================================//

            // history                 = {this.props.ParentProps.history}
            UserReducer             = {this.props.UserReducer}
          />

        </header>
      )
    }
  }
}
const mapStateToProps = (state) => {
  return {
      UserReducer: state.UserReducer,
      TenantReducer: state.TenantReducer,
      AssetTagReducer: state.AssetTagReducer
  };
};

const mapDispatchToProps = (dispatch) => {
    return {
        RunRedux: (data) => {
            dispatch(data);
        },
    };
};

// export default Header;
export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/App/views/components/Header/Header.js